import { render, staticRenderFns } from "./FolderTreeSelect.vue?vue&type=template&id=b716212a&scoped=true"
import script from "./FolderTreeSelect.vue?vue&type=script&lang=js"
export * from "./FolderTreeSelect.vue?vue&type=script&lang=js"
import style0 from "./FolderTreeSelect.vue?vue&type=style&index=0&id=b716212a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b716212a",
  null
  
)

export default component.exports